'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateTimeHelper = function () {
    function DateTimeHelper(format) {
        _classCallCheck(this, DateTimeHelper);

        if (!format) {
            throw 'format is required';
        }
        this._format = format;
        this._momentFormat = DateTimeHelper.getMomentFormat(format);
        this._allowedFormats = DateTimeHelper.getAllowedFormats(this.momentFormat);
        this._formatRegex = DateTimeHelper.getFormatRegex(this.momentFormat);
    }

    DateTimeHelper.prototype.parseValue = function parseValue(value) {
        if (value instanceof Date) {
            return DateTimeHelper.momentValue(value).format();
        }

        if (value.match(new RegExp(this.formatRegex))) {
            var momentValue = DateTimeHelper.momentValue(value, this.allowedFormats);
            if (momentValue.isValid()) {
                return momentValue.format();
            }
        }
        return value;
    };

    DateTimeHelper.prototype.formatValue = function formatValue(value) {
        var momentValue = DateTimeHelper.momentValue(value);
        if (momentValue.isValid()) {
            return momentValue.format(this.momentFormat);
        }
        return value;
    };

    DateTimeHelper.formatValue = function formatValue(value, format) {
        return new DateTimeHelper(format).formatValue(value);
    };

    DateTimeHelper.getFormatsForPart = function getFormatsForPart(format, allowedFormats, part) {
        var doublePart = '' + part + part;
        var formats = [].concat(allowedFormats);
        if (format.match(RegExp(doublePart))) {
            for (var i = 0; i < allowedFormats.length; i++) {
                formats.push(allowedFormats[i].replace(RegExp(doublePart), part));
            }
        } else if (format.match(RegExp(part))) {
            for (var _i = 0; _i < allowedFormats.length; _i++) {
                formats.push(allowedFormats[_i].replace(RegExp(part), doublePart));
            }
        }
        return formats;
    };

    DateTimeHelper.getAllowedFormats = function getAllowedFormats(format) {
        var allowedFormats = [format];

        ['s', 'm', 'H', 'D', 'M'].forEach(function (part) {
            allowedFormats = DateTimeHelper.getFormatsForPart(format, allowedFormats, part);
        });

        return allowedFormats;
    };

    DateTimeHelper.getFormatRegex = function getFormatRegex(format) {
        return new RegExp('^(' + format.replace('ss', DateTimeHelper.secondsRegex).replace('s', DateTimeHelper.secondsRegex).replace('mm', DateTimeHelper.minutesRegex).replace('m', DateTimeHelper.minutesRegex).replace('HH', DateTimeHelper.hoursRegex).replace('H', DateTimeHelper.hoursRegex).replace('H', DateTimeHelper.hoursRegex).replace('DD', DateTimeHelper.daysRegex).replace('D', DateTimeHelper.daysRegex).replace('MM', DateTimeHelper.monthsRegex).replace('M', DateTimeHelper.monthsRegex).replace('YYYY', DateTimeHelper.yearRegex) + ')$');
    };

    DateTimeHelper.getMomentFormat = function getMomentFormat(format) {
        return format.replace(new RegExp('d', 'g'), 'D').replace(new RegExp('y', 'g'), 'Y');
    };

    DateTimeHelper.prototype.momentValue = function momentValue(value) {
        var inputFormats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _moment2.default.ISO_8601;

        if (value instanceof Date) {
            return (0, _moment2.default)(value);
        }
        return (0, _moment2.default)(value, inputFormats, true);
    };

    DateTimeHelper.momentValue = function momentValue(value) {
        var inputFormats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _moment2.default.ISO_8601;

        if (value instanceof Date) {
            return (0, _moment2.default)(value);
        }
        return (0, _moment2.default)(value, inputFormats, true);
    };

    DateTimeHelper.parseValue = function parseValue(value, format) {
        return new DateTimeHelper(format).parseValue(value);
    };

    _createClass(DateTimeHelper, [{
        key: 'allowedFormats',
        get: function get() {
            return this._allowedFormats;
        }
    }, {
        key: 'format',
        get: function get() {
            return this._format;
        }
    }, {
        key: 'formatRegex',
        get: function get() {
            return this._formatRegex;
        }
    }, {
        key: 'momentFormat',
        get: function get() {
            return this._momentFormat;
        }
    }, {
        key: 'formatHasSeconds',
        get: function get() {
            return this.format.indexOf(':s') !== -1;
        }
    }, {
        key: 'formatHasMinutes',
        get: function get() {
            return this.format.indexOf(':m') !== -1;
        }
    }, {
        key: 'formatHasHours',
        get: function get() {
            return this.format.indexOf(':H') !== -1;
        }
    }], [{
        key: 'daysRegex',
        get: function get() {
            return '([0-9]|0[0-9]|[1-2][0-9]|3[0-1])';
        }
    }, {
        key: 'hoursRegex',
        get: function get() {
            return '([0-9]|0[0-9]|1[0-9]|2[0-3])';
        }
    }, {
        key: 'minutesRegex',
        get: function get() {
            return '([0-5]?[0-9])';
        }
    }, {
        key: 'monthsRegex',
        get: function get() {
            return '([0-9]|0[0-9]|1[0-2])';
        }
    }, {
        key: 'secondsRegex',
        get: function get() {
            return '([0-5]?[0-9])';
        }
    }, {
        key: 'yearRegex',
        get: function get() {
            return '([1-9][0-9]{3})';
        }
    }, {
        key: 'defaultDateFormat',
        get: function get() {
            return 'dd/MM/yyyy';
        }
    }, {
        key: 'defaultDateTimeFormat',
        get: function get() {
            return 'dd/MM/yyyy HH:mm';
        }
    }, {
        key: 'defaultTimeFormat',
        get: function get() {
            return 'HH:mm';
        }
    }]);

    return DateTimeHelper;
}();

exports.default = DateTimeHelper;


//////////////////
// WEBPACK FOOTER
// ./common/directives/datepicker/dateTimeHelper.js
// module id = 73
// module chunks = 0